// extracted by mini-css-extract-plugin
export default {"toggleGroup":"Toggle_toggleGroup__XeqoM","toggleButton":"Toggle_toggleButton__irZF2","active":"Toggle_active__-0Iyt"};